import type { Plugin } from 'vue'
import * as Sentry from '@sentry/vue'
import {
  API_AUTH_BASE_URL,
  API_BASE_URL,
  APP_URL,
  SENTRY_DSN,
  SENTRY_PROFILES_SAMPLE_RATE,
  SENTRY_TRACES_SAMPLE_RATE,
} from '@/constants'

export default {
  install: (app) => {
    const integrations = [Sentry.browserTracingIntegration()]

    if (import.meta.env.PROD) {
      integrations.push(Sentry.browserProfilingIntegration())
    }

    const tracesSampleRate = Number(SENTRY_TRACES_SAMPLE_RATE ?? 0.0)
    const profilesSampleRate = Number(SENTRY_PROFILES_SAMPLE_RATE ?? 0.0)

    Sentry.init({
      app,
      dsn: SENTRY_DSN,
      environment: import.meta.env.MODE,
      debug: import.meta.env.DEV,
      sendDefaultPii: true,
      integrations,
      tracesSampleRate,
      tracePropagationTargets: ['localhost', APP_URL, API_BASE_URL, API_AUTH_BASE_URL],
      profilesSampleRate: import.meta.env.PROD ? profilesSampleRate : undefined,
      beforeSend(event, hint) {
        const exception = hint?.originalException as
          Error | { response?: { status: number } } | null

        // Exclude all 4** exceptions
        if (
          exception &&
          'response' in exception &&
          exception.response!.status >= 400 &&
          exception.response!.status < 500
        ) {
          return null
        }

        return event
      },
    })
  },
} as Plugin
